import classnames from 'classnames';
import React from 'react';

import {type NamedPaymentMethod, paymentMethodName} from '../paymentMethodName';
import cs from './styles.module.scss';

/**
 * One rendering of a card or bank account for every surface that names one: Settings and the
 * Library checkout.
 */
export const PaymentMethodLabel: React.FunctionComponent<{
  method: NamedPaymentMethod;
  className?: string;
}> = ({method, className}) => (
  <span className={classnames(cs.paymentMethodLabel, className)}>
    <span className={cs.name}>{paymentMethodName(method)}</span>
    <span className={cs.last4}>•••• {method.last4}</span>
  </span>
);
